module.exports = __webpack_public_path__ + "img/icon_log_fields.fe9daa62.svg";